<template>
    <div class="iq-sub-dropdown dropdown-menu filter-component" aria-labelledby="dropdownMenuButton2">
        <div class="shadow-none m-0">
            <div class="card-body p-0" v-if="isMultiSelect">
                <div class="pb-3 pt-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="mb-0">{{ name }}</h5>
                    </div>
                </div>
                <div>
                    <treeselect :multiple="true" :options="options" placeholder="Select Status"
                        v-model="listSelected" />
                    <treeselect-value :value="value" />
                </div>
                <btn @click="setFilterMultiselect" class="btn btn-primary btn-block mt-3"
                    role="button">
                    Apply
            </btn>
            </div>
            <div class="card-body p-0" v-else>
                <div class="pb-3 pt-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="mb-0">{{ name }}</h5>
                    </div>
                </div>
                <div class="form-group"><label>Rule</label><select class="form-control mb-3">
                        <option value="1">Like</option>
                        <option value="2">Equal to</option>
                    </select></div>
                <div class="input-group mb-4">
                    <input v-model="filterText" type="text" :placeholder="name" aria-label="Username"
                        aria-describedby="basic-addon1" class="form-control">
                </div>
                <btn @click="setFilter" class="btn btn-primary btn-block mt-3"
                    role="button">
                    Apply
            </btn>
            </div>
        </div>
    </div>
</template>
<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
    components: { Treeselect },
    props: {
        name: { type: String },
        filterId: { type: String },
        isMultiSelect: { type: Boolean }
    },
    data() {
        return {
            filterText: '',
            options: [
            {
                id: 'complete',
                label: 'Complete'
            },
            {
                id: 'pending',
                label: 'Pending'
            },
            {
                id: 'canceled',
                label: 'Canceled'
            },
            {
                id: 'processing',
                label: 'Processing'
            }
        ],
            listSelected: []
        }
    },
    methods: {
        setFilter() {
            this.$store.commit('orderFilters/setFilter', { id: this.filterId, status: true, filterValue: this.filterText });
            this.$store.dispatch('fetchOrders');
        },
        setFilterMultiselect() {
            this.$store.commit('orderFilters/setFilter', { id: this.filterId, status: true, filterValue: this.listSelected });
            this.$store.dispatch('fetchOrders');
        }
    }
}
</script>
<style lang="scss">
.filter-component {
    min-width: 300px;
    padding: 10px;
}
</style>